import React from "react";
import { navigate } from "../../services";
import styled from "styled-components";
import { Button, BTN_MEDIUM } from "../../lib";
import { device } from "../../helpers/style";

export const Container = styled.div`
    user-select: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;

    @media ${device.phone} {
        margin-bottom: 20px;
    }
`;

export default function CreateDocLink() {
    return (
        <Container>
            <Button
                size={BTN_MEDIUM}
                messageId="doc.new"
                onClick={() => navigate.to("/app/doc/create")}
            />
        </Container>
    );
}
